export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
        return '';
    }
    const trimmed = phoneNumber.trim();
    const startsWithPlus = trimmed.startsWith('+');
    let digitsOnly = trimmed.replace(/\D/g, '');
    if (digitsOnly.length === 0) {
        return '';
    }
    if (startsWithPlus) {
        return '+' + digitsOnly;
    }
    if (digitsOnly.startsWith('00')) {
        return '+' + digitsOnly.substring(2);
    }
    const countryCode = getCountryCode();
    if (digitsOnly.startsWith('0')) {
        digitsOnly = digitsOnly.substring(1);
    }
    return `+${countryCode}${digitsOnly}`;
};
export const formatLinkNumber = (fullNumber) => {
    const prefix = window.siteSettings?.ptNumberCountryPrefix || '';
    const rawNumber = (fullNumber || '').trim();
    const cleanNumber = rawNumber.replace(/[ +\-\/]/g, '');
    if (rawNumber.startsWith('+')) {
        return '+' + cleanNumber;
    }
    if (!prefix) {
        return cleanNumber;
    }
    if (cleanNumber.startsWith('0')) {
        return prefix + cleanNumber.substring(1);
    }
    return prefix + cleanNumber;
};
const getCountryCode = () => {
    const lang = document.documentElement.lang.split('-')[0].toLowerCase();
    const hostname = window.location.hostname;
    const langToCountryCode = {
        de: '49',
        ch: '41',
        en: '44',
        it: '39',
        es: '34',
        jp: '81',
        fr: '33',
        nl: '31',
    };
    if (lang === 'de') {
        if (hostname.endsWith('.ch')) {
            return '41';
        }
        if (hostname.endsWith('.at')) {
            return '43';
        }
    }
    return langToCountryCode[lang] || '49';
};
export const formatNumbersInFormBuilderData = (data) => {
    const output = {};
    for (const key of Object.keys(data)) {
        output[key] = key.toLowerCase().includes('phone') ? formatPhoneNumber(data[key]) : data[key];
    }
    return output;
};
